observeElements() {
      this.$nextTick(() => {
        // Wait a bit more for DOM to be fully ready
        setTimeout(() => {
          const elementsToObserve = [
            this.$refs.titleElement,
            this.$refs.subtitleElement,
            this.$refs.contentElement,
            this.$refs.buttonElement
          ];

          elementsToObserve.forEach(element => {
            if (element && element instanceof Element && this.observer) {
              this.observer.observe(element);
            }
          });
        }, 100);
      });
    },<template>
  <div class="home-serivces layout-padding mt-24">
    <div class="grid grid-cols-2 gap-x-24 lg:gap-20 gap-y-10">
      <div class="col-span-2 lg:col-span-1 flex justify-between flex-col">
        <div>
          <div 
            ref="titleElement"
            class="text-8xl text-safetyBlack title-animate"
            :class="{ 'animate-in': titleVisible }"
          >
            {{ services.title }} 
          </div>
          <div 
            ref="subtitleElement"
            class="home-service-subtitle my-4 text-2xl subtitle-animate paragraph"
            :class="{ 'animate-in': subtitleVisible }"
          >
            {{ services.subtitle }}
          </div>
          <div 
            ref="contentElement"
            class="home-service-content content-animate paragraph"
            :class="{ 'animate-in': contentVisible }"
          >
            {{ services.description }}
          </div>
        </div>
        <div 
          ref="buttonElement"
          class="flex gap-2 button-animate mt-4"
          :class="{ 'animate-in': buttonVisible }"
        >
          <button class="btn-outlin rounded-full learn-more-btn2 ">
            <a
              class="flex items-center"
              style="color: oklch(27.8% 0.033 256.848) !important;"
              :href="services.catalogue"
              download="catalogue.pdf"
              target="_blank"
            >
              <span class="text-xl text-white" style="margin-left:24px;">{{ content.catalogue }}</span>
              <img src="/static/images/arrow-w.svg" class="w-6 ml-3 icon" />
            </a>
          </button>
        </div>
      </div>

      <router-link
        :to="`/services/${service.id}`"
        v-if="service"
        class="col-span-2 lg:col-span-1 service-card"
      >
        <div
          class="home-service-img rounded-3xl"
          :style="`background: url(${service.image})`"
        >
          <div class="img-overlay-on service-section flex items-end p-8">
            <div class="text-7xl text-white">{{ service.title }}</div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: ["services"],
  inject: ["content"],
  data() {
    return {
      titleVisible: false,
      subtitleVisible: false,
      contentVisible: false,
      buttonVisible: false,
      observer: null,
    };
  },
  computed: {
    stringLength() {
      let content;
      if (screen.width > 1000) {
        content = Math.round(screen.width / 15);
      } else if (screen.width < 1000 && screen.width > 600) {
        content = Math.round(screen.width / 7);
      } else if (screen.width < 600) {
        content = Math.round(screen.width / 8);
      }
      return content;
    },
    serviceContent() {
      let content = `Sed ut perspiciatis unde omnis iste natus error sit volup
             spiciatis unde omnis iste atis unde omnis iste natus error sit
             volup spici unde omnis iste natus error sit volup spiciatis unde
             omnis iste`;
      return content.toString().substring(0, this.stringLength);
    },
    service() {
      return this.services?.services.find((service) => service.id === 1);
    },
  },
  mounted() {
    this.setupIntersectionObserver();
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    setupIntersectionObserver() {
      const options = {
        root: null,
        rootMargin: "0px 0px -100px 0px",
        threshold: 0.1,
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const element = entry.target;
            
            // Add staggered delays for sequential animation
            if (element === this.$refs.titleElement) {
              setTimeout(() => {
                this.titleVisible = true;
              }, 100);
            } else if (element === this.$refs.subtitleElement) {
              setTimeout(() => {
                this.subtitleVisible = true;
              }, 300);
            } else if (element === this.$refs.contentElement) {
              setTimeout(() => {
                this.contentVisible = true;
              }, 500);
            } else if (element === this.$refs.buttonElement) {
              setTimeout(() => {
                this.buttonVisible = true;
              }, 700);
            }
          }
        });
      }, options);

      // Observe all elements with proper checks
      this.observeElements();
    },
    
    observeElements() {
      this.$nextTick(() => {
        // Wait a bit more for DOM to be fully ready
        setTimeout(() => {
          const elementsToObserve = [
            this.$refs.titleElement,
            this.$refs.subtitleElement,
            this.$refs.contentElement,
            this.$refs.buttonElement,
            this.$refs.imageElement
          ];

          elementsToObserve.forEach(element => {
            if (element && element instanceof Element && this.observer) {
              this.observer.observe(element);
            }
          });
        }, 100);
      });
    },
  },
};
</script>

<style scoped>
/* Base animation styles */
.title-animate,
.subtitle-animate,
.content-animate,
.button-animate {
  opacity: 0;
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Title animation */
.title-animate {
  transform: translateY(50px);
}

.title-animate.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* Subtitle animation */
.subtitle-animate {
  transform: translateY(30px);
}

.subtitle-animate.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* Content animation */
.content-animate {
  transform: translateY(20px);
}

.content-animate.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* Button animation */
.button-animate {
  transform: translateY(20px);
}

.button-animate.animate-in {
  opacity: 1;
  transform: translateY(0);
}
</style>